package tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.layout.wrapContentSize
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Chat
import androidx.compose.material.icons.filled.CheckBox
import androidx.compose.material.icons.filled.CheckBoxOutlineBlank
import androidx.compose.material.icons.filled.Circle
import androidx.compose.material.icons.filled.Groups
import androidx.compose.material.icons.filled.HourglassTop
import androidx.compose.material.icons.filled.Phone
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import tta.destinigo.talktoastro.shared.data.ButtonStatus
import tta.destinigo.talktoastro.shared.theme.Scale
import tta.destinigo.talktoastro.shared.theme.primaryDark

@Composable
fun QueueOptionCard(
    title: String,
    queueNo: String,
    waitTime: String,
    isSelected: Boolean,
    isAvailable: Boolean,
    buttonStatus: ButtonStatus,
    onSelect: () -> Unit
) {
    val backgroundColor = if (isSelected) MaterialTheme.colorScheme.primaryContainer else MaterialTheme.colorScheme.surface
    val borderColor = if (isSelected) primaryDark else primaryDark.copy(alpha = 0.2f)

    Surface(
        modifier = Modifier
            .fillMaxWidth().wrapContentHeight(),
        border = BorderStroke(1.dp, borderColor),
        shape = RoundedCornerShape(Scale.CORNER_SMALL)
    ) {

        Box(
            modifier = Modifier.fillMaxWidth().wrapContentHeight().clickable(enabled = isAvailable, onClick = onSelect),
        ) {

            Row(
                modifier = Modifier.fillMaxWidth().padding(16.dp),
                verticalAlignment = Alignment.Top
            ) {
                Column (
                    modifier = Modifier
                        .weight(1f),
                    verticalArrangement = Arrangement.Center
                ) {

                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.Start,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Icon(
                            imageVector = if (title.contains("Call")) Icons.Default.Phone else Icons.AutoMirrored.Filled.Chat,
                            contentDescription = title,
                            tint = Color.Black,
                            modifier = Modifier.size(Scale.GLOBAL_ICON_SIZE_MAX).background(
                                color = primaryDark.copy(alpha = 0.1f),
                                shape = RoundedCornerShape(4.dp)
                            ).padding(3.dp)
                        )
                        Spacer(modifier = Modifier.width(8.dp))

                        Text(
                            text = title,
                            style = MaterialTheme.typography.bodyLarge,
                            fontWeight = FontWeight.Bold
                        )
                        // Determine chat icon based on status
                        val (chatIconColor, chatContentDescription) = when (buttonStatus) {
                            ButtonStatus.ONLINE -> Color.Green to "Online"
                            ButtonStatus.BUSY -> Color.Yellow to "Busy"
                            ButtonStatus.OFFLINE -> Color.Gray to "Offline"
                            else -> Color.Gray to "Offline" // fallback
                        }

// Chat Icon Composable
                        Spacer(modifier = Modifier.width(4.dp))
                        Icon(
                            imageVector = Icons.Default.Circle,
                            contentDescription = chatContentDescription,
                            tint = chatIconColor,
                            modifier = Modifier.size(8.dp)
                        )

//// Determine call title based on call status
//                        val callTitle = when (isAvailable) {
//                            ButtonStatus.ONLINE -> "Call(Online)"
//                            ButtonStatus.BUSY -> "Call(Busy)"
//                            ButtonStatus.OFFLINE -> "Call(Offline)"
//                            else -> "Call" // fallback
//                        }

//                        if (isAvailable) {
//                            Spacer(modifier = Modifier.width(4.dp))
//                            Icon(
//                                imageVector = Icons.Default.Circle,
//                                contentDescription = "Online",
//                                tint = Color.Green,
//                                modifier = Modifier.size(8.dp)
//                            )
//                        } else {
//                            Spacer(modifier = Modifier.width(4.dp))
//                            Icon(
//                                imageVector = Icons.Default.Circle,
//                                contentDescription = "Offline",
//                                tint = Color.Gray,
//                                modifier = Modifier.size(8.dp)
//                            )
//                        }
                    }

                    Row {
                        BottomText(
                            modifier = Modifier.weight(1f).wrapContentHeight(),
                            icon = Icons.Default.Groups,
                            titleText = "Queue No.",
                            subTitleText = queueNo
                        )

                        VerticalDivider(
                            thickness = 1.dp,
                            modifier = Modifier.height(30.dp).padding(horizontal = 16.dp)
                        )

                        BottomText(
                            modifier = Modifier.weight(1f).wrapContentHeight(),
                            icon = Icons.Default.HourglassTop,
                            titleText = "Wait Time",
                            subTitleText = waitTime
                        )
                    }
                }

                if (isSelected) {
                    Icon(
                        modifier = Modifier.wrapContentSize(),
                        imageVector = Icons.Default.CheckBox,
                        contentDescription = "Selected",
                        tint = primaryDark
                    )
                }else{
                    Icon(
                        modifier = Modifier.wrapContentSize(),
                        imageVector = Icons.Default.CheckBoxOutlineBlank,
                        contentDescription = "Selected",
                        tint = primaryDark
                    )
                }
            }

        }

    }
}

@Composable
fun BottomText(
    modifier: Modifier,
    icon:ImageVector,
    titleText:String,
    subTitleText:String,
){
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Start
    ) {
        Spacer(modifier = Modifier.width(4.dp))
        Icon(
            imageVector = icon,
            contentDescription = "Queue No",
            modifier = Modifier.size(Scale.GLOBAL_ICON_SIZE_SMALL)
        )
        Spacer(modifier = Modifier.width(12.dp))
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            Text(
                text = titleText,
                style = MaterialTheme.typography.labelSmall.copy(
                    color = Color.Gray
                )
            )
            Text(
                text = subTitleText,
                style = MaterialTheme.typography.titleSmall
            )
        }
    }
}
